var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-more-box"},[(_vm.text === 'getMore')?_c('span',{on:{"click":_vm.getMore}},[_vm._v("点击加载更多")]):_vm._e(),(_vm.text === 'loading')?_c('span',[_vm._v("加载中。。。")]):_vm._e(),(_vm.text === 'noMore')?_c('span',[_vm._v("没有更多数据了")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }